import { createUseStyles } from 'react-jss'

export default createUseStyles({
  sliderPreview: {
    minHeight: 370,
    marginBottom: 32
  },
  slide: {
    minHeight: 360,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 8px'
  },
  skeletonSlideWrapper: {
    width: '100%',
    '& > span': {
      width: '100%'
    }
  }
})
